import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { loginUser } from "../../apis/api/AuthApi";
import { useDispatch,useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Lodderr from "../../components/Lodder/Lodder";
const Login = () => {  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const {loading} = useSelector((state) => state.AuthSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("password", data.password);
    formData.append("rememberMe", data.rememberMe);
    formData.append("loginFrom", "Web");
  
    const response = await dispatch(loginUser(formData));
  
    if (response?.payload?.status === "success") {
      const member = response.payload.data.member;
      const userId = member?.id;
      const company_id = member?.company_id;
      const token = response.payload.token;
      const access = JSON.stringify(response.payload.data.membership_plan);
  
      // Build full_name safely (no nulls)
      const nameParts = [
        member?.first_name,
        member?.middle_name,
        member?.last_name,
      ].filter((part) => part && part !== "null" && part !== "undefined");
      const full_name = nameParts.join(" ");
  
      // Build user object with safe fallbacks
      const user = JSON.stringify({
        fullname: full_name || "Guest User",
        company_name: member?.company_name ?? "No Company",
        member_logo: member?.member_logo ?? "/gray-avatar-icon-vector-illustration_276184-163.avif",
      });
  
      // Set cookies
      Cookies.set("token", token);
      Cookies.set("userID", userId);
      Cookies.set("company_id", company_id);
      Cookies.set("access", access);
      Cookies.set("user", user);
  
      toast.success("Login Successful");
      navigate("/dashboard");
    } else if (response?.payload?.status === "error") {
      toast.error(response?.payload?.message);
      navigate("/");
    }
  };
  

  return (
    <>
       {loading && <Lodderr/>}
      <div
        className="wrapper bg-login pace-done"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/logistic.jpg)`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
        }}
      >
        <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
          <div className="container-fluid">
            <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
              <div className="col mx-auto">
                <div
                  className="card rounded-4"
                  style={{
                    backgroundColor: "rgb(255 255 255 / 89%)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(7px)",
                    color: "rgb(0 0 0)",
                  }}
                >
                  <div className="card-body">
                    <div className="border p-4 rounded-4">
                      <div className="text-center">
                        <div
                          style={{
                            width: "200px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            margin: "auto",
                            background: "transparent",
                          }}
                        >
                          <img
                            src="assets/images/5ca.png"
                            alt="Logo"
                            style={{
                              maxWidth: "150%",
                              maxHeight: "150%",
                              objectFit: "contain",
                              background: "transparent",
                            }}
                          />
                        </div>
                        <h5 className="mt-3 mb-0">Hi, Member</h5>
                        <p className="mb-4">
                          Please login before entering the Member panel.
                        </p>
                      </div>

                      <div className="form-body">
                        <form
                          className="row g-3"
                          onSubmit={handleSubmit(onSubmit)}
                        >
                          <div className="col-12">
                            <label
                              htmlFor="inputEmailAddress"
                              className="form-label"
                            >
                              Email Address
                            </label>
                            <input
                              type="email"
                              className={`form-control rounded-5 ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="inputEmailAddress"
                              placeholder="Email Address"
                              {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value:
                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                  message: "Invalid email format",
                                },
                              })}
                            />
                            {errors.email && (
                              <div className="invalid-feedback">
                                {errors.email.message}
                              </div>
                            )}
                          </div>
                          <div className="col-12">
                            <label
                              htmlFor="inputChoosePassword"
                              className="form-label"
                            >
                              Password
                            </label>
                            <input
                              type="password"
                              className={`form-control rounded-5 ${
                                errors.password ? "is-invalid" : ""
                              }`}
                              id="inputChoosePassword"
                              placeholder="Enter Password"
                              {...register("password", {
                                required: "Password is required",
                                
                              })}
                            />
                            {errors.password && (
                              <div className="invalid-feedback">
                                {errors.password.message}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexSwitchCheckChecked"
                                {...register("rememberMe")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckChecked"
                              >
                                Remember Me
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 text-end">
                            <a href="authentication-forgot-password.html">
                              Forgot Password?
                            </a>
                          </div>
                          <div className="col-12">
                            <div className="d-grid">
                              <button
                                type="submit"
                                className="btn btn-gradient-info rounded-5"
                              >
                                <i className="bx bxs-lock-open"></i> Sign in
                              </button>
                            </div>
                          </div>

                          <div className="col-12 text-center">
                            <p className="mb-0">
                              Don't have an account yet?{" "}
                              <Link to="/signUp">Sign up here</Link>
                            </p>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
